
import { Component, Vue, Watch } from "vue-property-decorator";
import { TTeammates_Select, TCase_Redistribution } from "@/models/company_teammates";
import { SMApp, SMTeammates } from "@/store";

const TEAMMATES_ROUTE = "Teammates";

@Component({
  components: {
    ApplicationsTable: () => import("@/modules/Compliance/Teammates/Remove/ApplicationsTable.vue"),
    ActionButtons: () => import("@/components/ActionContainer/ActionButtons.vue"),
  },
})
export default class RemoveTeammate extends Vue {
  сomplianceAdminId = 0;

  сomplianceTeammateOA = 0;

  isReAssignOpen = false;

  get loading(): boolean {
    return SMTeammates.loading;
  }

  get teammatesAdminOptions(): TTeammates_Select[] {
    return SMTeammates.teammatesAdminOptions;
  }

  get teammatesOptions(): TTeammates_Select[] {
    return SMTeammates.teammatesOptions.filter(
      (teammate) => !teammate.label.includes(SMTeammates.status.email)
    );
  }

  get cases() {
    return SMTeammates.cases;
  }

  get isComplianceAdmin() {
    return SMTeammates.status.is_compliance_admin;
  }

  get isHasCases() {
    return SMTeammates.status.is_has_cases;
  }

  get teammateName() {
    return SMTeammates.status.teammate_name;
  }

  updatePageTitle() {
    SMApp.setPageTitle(`${this.$root.$tc("caption.remove")} ${this.teammateName}`);
  }

  async mounted() {
    this.updatePageTitle();
  }

  get userId(): number {
    return Number(this.$route.params.teammateId ?? 0);
  }

  @Watch("userId", { immediate: true })
  async onUserIdChange(val: number, prevVal: number) {
    if (!val || val === prevVal) return;

    await this.update(val);
  }

  async update(userId = 0) {
    if (!this.teammatesOptions.length) await SMTeammates.getTeammates();

    if (!this.teammatesAdminOptions.length) await SMTeammates.getTeammates(true);

    const id = userId ? userId : this.userId;

    if (!SMTeammates.cases.length) await SMTeammates.getTeammatesDeleteStatus(id);

    SMTeammates.setLoading(false);
  }

  caseRedistribution: TCase_Redistribution[] = [];

  setCaseRedistribution(caseRedistribution: TCase_Redistribution[]) {
    this.caseRedistribution = caseRedistribution;
  }

  @Watch("isReAssignOpen", { immediate: true })
  isReAssignOpenChanged(value: boolean) {
    if (value) return;

    this.сomplianceTeammateOA = 0;

    this.caseRedistribution = [];
  }

  get isRemoveEnabled() {
    const {
      isComplianceAdmin,
      сomplianceAdminId,
      сomplianceTeammateOA,
      isHasCases,
      caseRedistribution,
      isReAssignOpen,
    } = this;

    const isTeammateCases =
      caseRedistribution.length && caseRedistribution.length === SMTeammates.cases.length;

    if (isComplianceAdmin && !isHasCases) return !!сomplianceAdminId;

    if (isComplianceAdmin && isHasCases && isReAssignOpen)
      return !!сomplianceAdminId && !!сomplianceTeammateOA;

    if (isComplianceAdmin && isHasCases && !isReAssignOpen)
      return !!сomplianceAdminId && isTeammateCases;

    if (!isComplianceAdmin && isHasCases && isReAssignOpen) return !!сomplianceTeammateOA;

    if (!isComplianceAdmin && isHasCases && !isReAssignOpen) return isTeammateCases;

    return false;
  }

  async cancel() {
    await this.$router.push({
      name: TEAMMATES_ROUTE,
    });
  }

  async deleteTeammate() {
    if (!this.isRemoveEnabled || !this.userId) return;

    const new_compliance_admin_id = this.сomplianceAdminId;

    const case_redistribution = this.isReAssignOpen
      ? SMTeammates.cases.map((item) => {
          return {
            case_id: item.id,
            user_id: this.сomplianceTeammateOA,
          };
        })
      : this.caseRedistribution;

    const params = {
      new_compliance_admin_id,
      case_redistribution,
    };

    await this.$nextTick();

    await SMTeammates.deleteTeammate({ userId: this.userId, params });

    await this.cancel();
  }
}
